import type React from 'react';
import { useLayoutEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

import type { DetailSpetifications } from '@src/library/models/shop';

import * as st from './index.module.scss';

interface Props {
	specifications: DetailSpetifications[];
}

const Specifications: React.FC<Props> = ({ specifications }: Props) => {
	const location = useLocation();

	const [elementHeight, setElementHeight] = useState<number>(0);
	const elementRef = useRef<HTMLDivElement>(null);

	useLayoutEffect(() => {
		const calculateDynamicHeight = () => {
			if (elementRef.current) {
				const windowHeight = window.innerHeight;
				const elementPosition = elementRef.current.getBoundingClientRect().top;
				const calculatedHeight = windowHeight - elementPosition;
				setElementHeight(calculatedHeight);
			}
		};

		calculateDynamicHeight();

		window.addEventListener('load', calculateDynamicHeight);
		window.addEventListener('resize', calculateDynamicHeight);

		return () => {
			window.removeEventListener('load', calculateDynamicHeight);
			window.removeEventListener('resize', calculateDynamicHeight);
		};
	}, []);

	return (
		<div
			ref={elementRef}
			className={st.main}
			style={{
				minHeight: `${elementHeight - 20}px`,
			}}
		>
			{specifications ? (
				<div
					className={st.row}
					style={{
						gridTemplateRows: `repeat (${specifications.length}, min-content)`,
					}}
				>
					{specifications.map((spec: DetailSpetifications) => {
						return (
							<>
								<div className={st.title} key={spec.id}>
									{spec.title}
								</div>
								<div className={st.value}>{spec.value}</div>
							</>
						);
					})}
				</div>
			) : (
				''
			)}
		</div>
	);
};

export default Specifications;
